// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CommandIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Command/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.333 6.667H6.667v6.666h6.666V6.667ZM1.667 15.833c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5v-2.5h-2.5a2.507 2.507 0 0 0-2.5 2.5ZM4.167 1.667a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5h2.5v-2.5c0-1.375-1.125-2.5-2.5-2.5ZM18.333 4.167c0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 0 0-2.5 2.5v2.5h2.5c1.375 0 2.5-1.125 2.5-2.5ZM15.833 13.333h-2.5v2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5Z"
}));
export default CommandIcon;